export default "__VITE_ASSET__DxF4Qk$L__"